import { useState } from "react";
import { RotativoInputCard } from "./components/RotativoInputCard";
import { RotativoResponse } from "./components/RotativoResponse";
import type { RotativoResultsType } from "./calculadora-rotativo";

export default function CalculadoraJurosRotativo() {
  const [results, setResults] = useState<RotativoResultsType | null>(null);

  return (
    <>
      <RotativoInputCard setResults={setResults} />
      {results && <RotativoResponse results={results} />}
    </>
  );
}